import { render, staticRenderFns } from "./NavMenu.vue?vue&type=template&id=2b2c2a8b&scoped=true"
import script from "./NavMenu.vue?vue&type=script&lang=ts"
export * from "./NavMenu.vue?vue&type=script&lang=ts"
import style0 from "./NavMenu.vue?vue&type=style&index=0&id=2b2c2a8b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2c2a8b",
  null
  
)

export default component.exports